var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeCloseLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.04923 9.31077C3.01728 9.21295 3 9.10849 3 9C3 8.44772 3.44772 8 4 8C4.4597 8 4.84695 8.31019 4.96387 8.73268C7.04968 15.7186 16.9456 15.7202 19.0348 8.73735C19.1502 8.31248 19.5386 8 20 8C20.5523 8 21 8.44772 21 9C21 9.10681 20.9833 9.2097 20.9522 9.30621C20.5515 10.6482 19.9241 11.7876 19.1387 12.7244L20.4143 14C20.8048 14.3905 20.8048 15.0237 20.4143 15.4142C20.0238 15.8047 19.3906 15.8047 19.0001 15.4142L17.6887 14.1028C16.9745 14.6426 16.1912 15.0655 15.3686 15.3716L15.7264 16.7071C15.8694 17.2406 15.5528 17.7889 15.0193 17.9318C14.4858 18.0748 13.9375 17.7582 13.7946 17.2247L13.4311 15.8682C12.4836 16.0084 11.5164 16.0084 10.5689 15.8682L10.2054 17.2247C10.0625 17.7582 9.51416 18.0748 8.9807 17.9318C8.44723 17.7889 8.13065 17.2406 8.27359 16.7071L8.63144 15.3716C7.80891 15.0655 7.0256 14.6426 6.31146 14.1029L5.00017 15.4142C4.60964 15.8047 3.97648 15.8047 3.58596 15.4142C3.19543 15.0237 3.19543 14.3905 3.58596 14L4.86147 12.7245C4.07689 11.7887 3.45009 10.6508 3.04923 9.31077Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeCloseLine);
export default __webpack_public_path__ + "static/media/eye_close_line.d656183b55ba4adc93eb0bfae33a27ba.svg";
export { ForwardRef as ReactComponent };